import { useCallback, useState } from 'react'

import { useLocationStore } from '@entities/Location'
import { MenuItemEntity, useMenu } from '@entities/Menu'

import { AddressPicker } from '@features/address-picker'
import { ScrollableMenu } from '@features/scrollable-menu'
import { useAddressStore } from '@features/shipping-methods'
import { WorkingMode, WorkingModeSelector } from '@features/working-mode-selector'

import useDeliveryModal from '@widgets/modal-delivery/ui/useDeliveryModal'

import { TOPLINE_MENU_CODE } from '@shared/contants'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

export type SubComponent = 'WorkingMode' | 'AddressPicker' | 'ScrollableMenu'

export type HeaderWithComponentsProps = {
  disabledParts: SubComponent[]
}

export default function HeaderWithComponents (props: HeaderWithComponentsProps) {
  const { disabledParts = [] } = props
  const [ workingMode, setWorkingMode ] = useState<WorkingMode>('delivery')
  const { currentCity } = useLocationStore()
  const { selectedAddress } = useAddressStore()
  const { openDeliveryModal } = useDeliveryModal()

  const { menu } = useMenu({ code: TOPLINE_MENU_CODE })

  const mapMenuItems = useCallback((rawMenuItems: MenuItemEntity[] = []) => {
    return rawMenuItems.map(item => ({
      id: item.id,
      label: item.title,
      icon: item.icon_url ?? '',
      iconBgColor: item.icon_color ?? 'transparent',
      href: item.link_url,
      onClick () {
        // TODO: Handle depending on link_type?
      }
    }))
  }, [ ])

  const handleAddressClick = () => {
    openDeliveryModal()
  }

  return (
    <div className={cn(styles.headerWithComponents)}>
      <div className={styles.headerWithComponents__content}>
        {!disabledParts.includes('WorkingMode') && (
          <WorkingModeSelector
            className={styles.headerWithComponents__workingMode}
            value={workingMode}
            onChange={setWorkingMode}
          />
        )}

        {!disabledParts.includes('AddressPicker') && (<AddressPicker
          className={styles.headerWithComponents__addressPicker}
          city={currentCity?.name}
          address={selectedAddress?.address ?? ''}
          onClick={handleAddressClick}
        />)}

        {!disabledParts.includes('ScrollableMenu') && (<ScrollableMenu
          className={styles.headerWithComponents__scrollableMenu}
          items={mapMenuItems(menu?.menuItems)}
        />)}
      </div>
    </div>
  )
}
